import Vue from 'vue';

import Locale from './vue-i18n-locales.generated';

// const lang = document.documentElement.lang ? document.documentElement.lang.substr(0, 2) : 'ua'
const lang = localStorage.getItem('language');

console.log(lang, 'lang');

import VueInternationalization from 'vue-i18n';
Vue.use(VueInternationalization);

const i18n = new VueInternationalization({
    locale: lang,
    messages: Locale,
    silentTranslationWarn: true
});

new Vue({
    i18n
});

export default i18n;
